import { toast } from 'react-toastify';
import { NXCross, NXCheck } from "./icons";


const deleteAllCookies = (): void => {
    const cookies: string[] = document.cookie.split(";");
    const preservedCookies = ['apiBase', 'apiHistory'];

    cookies.forEach(cookie => {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();

        // Skip preserved cookies
        if (preservedCookies.includes(name)) {
            return;
        }

        // Set the cookie's expiration date to a past date
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
};

const handleRetriveError = (error: any): void => {
    toast.error("An error occurred. Please try again later.");
};

const fireErrorIfNot404 = (error: any): void => {
    if (error.response.status !== 404) {
        handleRetriveError(error);
    }
}

const boolIndicator = (status: boolean) => (
    status ? <NXCheck className="text-green-500 w-6 h-6" /> : <NXCross className="text-red-500 w-6 h-6" />
);

const getQueryVariables = (searchParams: any) => {
    const variables: any = {};
  
    // Loop through all query parameters
    searchParams.forEach((value: string, key: string) => {
      // Only convert `first` and `last` to integers
      if (key === "first" || key === "last") {
        variables[key] = parseInt(value || "5");
      } else {
        variables[key] = value;
      }
    });
  
    return variables;
  };
  


export { deleteAllCookies, handleRetriveError, fireErrorIfNot404, boolIndicator, getQueryVariables };
